import { Modal } from 'antd';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $infoModal, resetInfoModalEv } from '../../models/zoom7Model/index.js';
import { public_info } from '../../data/public_info.js';
import { $queryLang } from '../../models/mapModel/index.js';

function PublicInfoModal() {
  const infoModal = useUnit($infoModal);
  const resetInfoModal = useUnit(resetInfoModalEv);
  const queryLang = useUnit($queryLang);
  const { t } = useTranslation();

  return (
    <Modal open={!!infoModal} centered footer={null} onCancel={resetInfoModal}>
      {infoModal && (
        <>
          <div style={{ fontWeight: 'bold', fontSize: 18, marginRight: 15 }}>
            {queryLang === 'kz' ? t(infoModal) : public_info[infoModal].title}
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html:
                queryLang === 'kz'
                  ? t(`${infoModal}_info`)
                  : public_info[infoModal].desc,
            }}
          />
        </>
      )}
    </Modal>
  );
}

export default PublicInfoModal;
